// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OdF-","input":"styles_input__hJL0u"};